<template>
  <h2 class="text-primary bg-secondary">
    おしらせ
  </h2>
  <v-card class="mx-auto" max-width="1280" variant="Tonal">
    <v-list :items="items" item-props lines="three">
      <template v-slot:subtitle="{ subtitle }">
        <div v-html="subtitle" class="subtitle_text"></div>
      </template>
    </v-list>
  </v-card>
</template>

<script>
  export default {
    data: () => ({
      items: [
        {
          title: "2024/2/21",
          subtitle: `当日イベントのページと出展タイトルのページを更新しました`,
        },
        // ↓仕切りボーダー
        {
          type: "divider",
          color: "primary",
          class: "border-opacity-50",
          thickness: "2",
        },
        {
          title: "2024/2/19",
          subtitle: `当日イベントのページを更新しました`,
        },
        // ↓仕切りボーダー
        {
          type: "divider",
          color: "primary",
          class: "border-opacity-50",
          thickness: "2",
        },
        {
          title: "2024/2/7",
          subtitle: `出展タイトルのページを更新しました`,
        },
        // ↓仕切りボーダー
        {
          type: "divider",
          color: "primary",
          class: "border-opacity-50",
          thickness: "2",
        },
        {
          title: "2024/1/25",
          subtitle: `第二回ふしぎなゲーム祭りのサイトをオープンしました`,
        },
        // ↓仕切りボーダー
        {
          type: "divider",
          color: "primary",
          class: "border-opacity-50",
          thickness: "2",
        },
      ],
    }),
  };
</script>

<style scoped>
  h2 {
    font-family: "rocknroll-one", sans-serif;
    font-weight: bold;
    font-style: normal;
    letter-spacing: 0.2em;
    padding: 0.5em 1em; /*文字周りの余白*/
    border-left: solid 5px rgb(var(--v-theme-primary)); /*左線（実線 太さ 色）*/
    max-width: 1280px;
    margin: 0 auto;
  }
  .subtitle_text {
    font-size: 1.2em;
    line-height: 2em;
  }
</style>
